import { useEffect } from 'react';
import { useHeaderStore } from 'src/store';

import styles from './Sticky.module.scss';

interface StickyProps {
    children: React.ReactNode;
}

const Sticky = ({ children }: StickyProps) => {
    const isFixed = useHeaderStore(({ isFixed }) => isFixed);
    const setIsProductStickyHeaderVisible = useHeaderStore(
        ({ setIsProductStickyHeaderVisible }) => setIsProductStickyHeaderVisible
    );

    useEffect(() => {
        setIsProductStickyHeaderVisible(isFixed);

        return () => {
            setIsProductStickyHeaderVisible(false);
        };
    }, [isFixed, setIsProductStickyHeaderVisible]);

    if (!isFixed) {
        return <div>{children}</div>;
    }

    return (
        <div>
            <div className={styles.spacer} />
            <div className={styles.fixed}>{children}</div>
        </div>
    );
};

export default Sticky;
